import React from 'react';
import { Icon } from './Icon.js';
export const IconNotebookBookmark = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M14 2V9.5L17 8L20 9.5V2", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M9 22V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M21 3H5V21H19V12.3525L21 13.3525V23H3V1H21V3Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconNotebookBookmark.js.map